import * as yup from 'yup';

const phoneRegEx = /^[0-9]+$/;
const name = yup
  .string()
  .trim()
  .required('نام الزامی می‌باشد.')
  .max(50, 'نام نباید بیشتر از ۵۰ کاراکتر شود.');
const phone_number = yup
  .string()
  .trim()
  .required('شماره تلفن الزامی می‌باشد.')
  .matches(phoneRegEx, 'شماره تلفن صحیح نیست، نمونه صحیح: 09121234567.');
const city = yup
  .string()
  .trim()
  .required('شهر الزامی می‌باشد.')
  .max(25, 'نام شهر نباید بیشتر از ۲۵ کاراکتر شود.');
const province = yup
  .string()
  .trim()
  .required('استان الزامی می‌باشد.')
  .max(25, 'نام استان نباید بیشتر از ۲۵ کاراکتر شود.');
const postal_code = yup
  .string()
  .trim()
  .required('کدپستی الزامی می‌باشد.')
  .matches(/^\d+$/, 'کد پستی باید شامل اعداد و بدون فاصله باشد.')
  .length(10, 'کد پستی باید دقیقا ۱۰ رقم باشد.');
const address = yup
  .string()
  .trim()
  .required('نشانی الزامی می‌باشد.')
  .max(100, 'نشانی نمیتواند بیشتر از ۱۰۰ کاراکتر باشد.');
const addressPersonal = yup
  .string()
  .trim()
  .max(100, 'نشانی نمیتواند بیشتر از ۱۰۰ کاراکتر باشد.')
  .notRequired();
const national_id = yup
  .string()
  .trim()
  .required('کدملی/شناسه ملی الزامی میباشد.')
  .matches(/^\d+$/, 'کدملی/شناسه ملی باید شامل اعداد و بدون فاصله باشد.')
  .min(10, 'کدملی/شناسه ملی باید حداقل ۱۰ رقم باشد.');
const economical_number = yup
  .string()
  .trim()
  .required('شماره اقتصادی الزامی می‌باشد.')
  .matches(/^\d{14}$/, 'شماره اقتصادی باید دقیقا ۱۴ رقم عددی باشد.');
const economical_number_legal = yup.string().trim();
const registration_code = yup.string().trim().required('کد ثبت الزامی میباشد.');

export const legalFormValidation = (isLegal: boolean) =>
  isLegal
    ? yup.object().shape({
        name,
        phone_number,
        province,
        city,
        postal_code,
        address,
        national_id,
        economical_number: economical_number_legal,
        registration_code,
      })
    : yup.object().shape({
        name,
        economical_number,
        address: addressPersonal,
        national_id,
      });
